import React from 'react';
import Form from 'react-bootstrap/Form';
import clsx from 'clsx';

export interface RadioButtonItem {
  label: string;
  value: string;
}

interface RadioButtonProps {
  id: string;
  label: string;
  isChecked: boolean;
  onChange: (item: string) => void;
  disabled?: boolean;
  inline?: boolean;
}

const RadioButton = (props: RadioButtonProps) => {
  return (
    <div
      key={props.id}
      id={'qa-radio-btn-' + props.id}
      onClick={() => {
        props.disabled !== true && props.onChange(props.id);
      }}
      className={clsx('custom-control custom-radio', props.inline ? 'd-inline-block' : undefined)}
    >
      <Form.Control
        disabled={props.disabled === true}
        id={'qa-form-control-' + props.id}
        type="radio"
        checked={props.isChecked}
        onChange={() => props.onChange(props.id)}
        className="custom-control-input cursor-pointer"
      />
      <Form.Label className="custom-control-label cursor-pointer">{props.label}</Form.Label>
    </div>
  );
};

export default RadioButton;
